import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { cloneDeep } from 'lodash-es'
import { processGroupsAndUsers } from '@/lib/dataProcessor/dataHandlers'
import { apiClientV1 } from '@/ContextTab/services/apiClient'
import type { DataOfUserStatusListGetOut } from '@/api/generated/v1'


// TODO: заменить на корректный тип из api v2, в v1 он некорректен UsersNotInGroupsOfDataOfGroupAndUserListGetOut
export interface IAuthorTreeItem {
  id: number
  uid: string
  asoi_mailbox_id: number
  code: string
  first_name: string | null
  is_active: boolean
  is_blocked: boolean
  is_online: boolean
  last_name: string | null
  last_seen: string | null
  name: string
  patronymic: string | null
  pos: number
  isUser: boolean
  // ! Тут может быть массив uid или id в зависимости от того откуда в сторе мы это забрали >:(
  track: (number | string)[]
  // а тут вроде только uid...
  children: string[]
  // TODO: см выше
  // ! поля используются, но не были тут объявлены ранее
  isGroup: boolean
  is_mail: boolean
  is_hidden: boolean
  // поле используется в ShareModal
  is_group: boolean
}

export const useGroupsAndUsersStore = defineStore('groupsAndUsers', () => {

  const groupAndUsersById = ref<Record<number, IAuthorTreeItem>>({})
  const groupAndUsersByUid = ref<Record<string, IAuthorTreeItem>>({})
  const userStatuses = ref<DataOfUserStatusListGetOut[]>([])

  const recipients = computed(() => {
    const _groupsAndUsersById = cloneDeep(groupAndUsersById.value)

    userStatuses.value.forEach((userItem) => {
      const user = _groupsAndUsersById[userItem.user_id]

      if (user) {
        user.is_online = userItem.is_online
        user.last_seen = userItem.last_seen
      }
    })

    const recipients = Object.values(_groupsAndUsersById).filter((item) => {
      if (item.isGroup) {
        return item.is_mail && !item.is_hidden
      } else {
        return item.asoi_mailbox_id !== null && item.is_active
      }
    })

    type UserLike = { name: string, [key: string]: any }

    const sortFn = (a: UserLike, b: UserLike) => {
      const nameA = a.name.toLowerCase()
      const nameB = b.name.toLowerCase()
      if (nameA < nameB) {
        return -1
      }

      if (nameA > nameB) {
        return 1
      }
      return 0
    }

    const groups = recipients
      .filter(({ isGroup }) => isGroup)
      .map((el) => ({
        ...el,
        name: el.name,
        is_group: true,
        id: Number(String(el.id).replace('G', '')),
      }))
      .sort(sortFn)

    const users = recipients
      .filter(({ isUser }) => isUser)
      .map((el) => ({ ...el, name: el.name, is_group: false }))
      .sort(sortFn)

    return [...groups, ...users]
  })

  const groupsAndNonBlockedUsersByUid = computed(() => {
    const filtered: Record<string, IAuthorTreeItem> = {}
    Object.entries(groupAndUsersByUid.value ?? {})
      .forEach(([uid, item]) => {
        if (item.isUser && item.is_blocked) {
          return
        }
        filtered[uid] = item
      })
    return filtered
  })

  async function fetchData() {
    // TODO: метод из v2 отличается по ответу от v1, мигрировать аккуратно
    const response = await apiClientV1.UsersService.getGroupsAndUsers()

    if (response?.data?.data) {
      const { itemsById, itemsByUid } = processGroupsAndUsers(response.data.data)
      groupAndUsersById.value = itemsById
      groupAndUsersByUid.value = itemsByUid
      return response.data.data
    }

    return response.data?.data
  }

  async function fetchUserStatuses() {
    const response = await apiClientV1.UsersService.getUsersStatuses()

    if (response?.data?.data) {
      userStatuses.value = response.data.data
    }
  }

  return {
    groupAndUsersById,
    groupAndUsersByUid,
    groupsAndNonBlockedUsersByUid,
    recipients,

    fetchData,
    fetchUserStatuses,
  }
})
